import React from "react";
import Image from "next/image";
import Marquee from "react-fast-marquee";
import { ChipWithImage } from "@components/MiniComponents";
import { BASE_ASSETS_URL } from "../../../constants/constants";

const Slider = ({
  heading,
  sliderImagesData,
  cardsData,
  styling,
  direction = "left",
}) => {
  return (
    <div
      className={`w-full h-full flex flex-col gap-10 justify-center items-center overflow-hidden ${styling}`}
    >
      {heading && (
        <h2 className="px-4 md:px-8 text-2xl md:text-3xl font-bold text-center">
          {heading}
        </h2>
      )}
      <div className={`max-w-screen-mxl mx-auto`}>
        {sliderImagesData && (
          <Marquee
            gradient={false}
            gradientColor="#fee2e2bf"
            speed={50}
            className="bg-transparent h-[80px]"
          >
            {sliderImagesData?.map((image, index) => (
              <div className="mx-8 sm:mx-12" key={index}>
                <Image
                  src={`${BASE_ASSETS_URL}/v2/marquee/${image}`}
                  width={150}
                  height={100}
                  alt="customer"
                  className={`h-auto`}
                />
              </div>
            ))}
          </Marquee>
        )}
        {cardsData && (
          <Marquee
            gradient={false}
            direction={direction ? direction : "left"}
            gradientColor="#fee2e2bf"
            speed={50}
            className="bg-transparent h-fit"
          >
            {cardsData.map((card, index) => (
              <div key={index} className="mx-4">
                <ChipWithImage {...card} />
              </div>
            ))}
          </Marquee>
        )}
      </div>
    </div>
  );
};

export default Slider;
